import React from 'react';
import * as styles from './marker.module.scss';

interface IMarkerProps {
  lat: number;
  lng: number;
}

export const Marker = ({}: IMarkerProps) => {
  return <div className={styles.wrapper}></div>;
};
